export default __webpack_public_path__ + "static/genome_canada-c5987f57bafe3f162651f33ce19193b4.png";